import React, { Component } from 'react';
import { do_action } from '../../actions'

class ContactUs extends Component {
    constructor(props) {
        super(props)
        this.state = {
            name: '',
            email: '',
            subject: '',
            message: ''
        }

        this.onChangeInput = this.onChangeInput.bind(this)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    onChangeInput = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }

    submitMessage(e) {
        let {email, message, name, subject} = this.state
        if (!email || !message || !name || !subject)
            return alert('Please fill full info')
        
        do_action('send_mail_contact', this.state )
            .then(data => {
                alert('Send mail success')
                this.setState({
                    name: '',
                    email: '',
                    subject: '',
                    message: ''
                })
            })
            .catch(err => console.log(err))
    }

    render() {
        return (
            <div className="contact-us">
                <div className="map">
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15955.1261457192!2d103.8556596!3d1.3062148!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6113959ccfdd5e25!2sRUHU%20PTE%20LTD%20-%20Direct%20Contractor%20Singapore!5e0!3m2!1svi!2s!4v1582601548364!5m2!1svi!2s" width="100%" height="450" frameborder="0" allowfullscreen=""></iframe>
                </div>
                <div className="contact-form">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12 col-sm-8 col-md-8 col-lg-7">
                                <div className="form">
                                    <h1 className="fontSemiBold">Send Us a Message</h1>
                                    <p>For interested parties who wish to visit our warehoure, kindly call/email us to arrange for an appointment.</p>
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                            <div className="form-group">
                                                <input type="text" className="form-control form-control-mix" name="name" value={this.state.name} placeholder="Your Name" onChange={this.onChangeInput}/>
                                            </div>
                                        </div>
                                        <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                            <div className="form-group">
                                                <input type="text" className="form-control form-control-mix" name="email" value={this.state.email} placeholder="Your Mail" onChange={this.onChangeInput}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <input type="text" className="form-control form-control-mix" name="subject" value={this.state.subject} placeholder="Contact Number" onChange={this.onChangeInput}/>    
                                    </div>
                                    <div className="form-group">
                                        <textarea cols="30" rows="5" className="form-control form-control-mix" placeholder="Your Message" style={{resize: "none"}} name="message" value={this.state.message} onChange={this.onChangeInput}/>
                                    </div>
                                    <div className="form-group">
                                        <button className="btn bg-blue fontMedium send" onClick={this.submitMessage.bind(this)}>Send</button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-5">
                                <div className="info">
                                    <h3 className="fontSemiBold marginT0">Ruhu</h3>
                                    <div>UEN No: 201820052N</div>
                                    <p>#109 Jalan Besar, 208829</p>
                                    <ul className="list-unstyled list">
                                        {/* <li>
                                            <span className="fa fa-envelope icon"></span>
                                            <div>Sale@eventpartner.com.sg</div>
                                        </li> */}
                                        <li>
                                            <span className="fa fa-phone icon"></span>
                                            <div>+65 63980900</div>
                                        </li>
                                        <li>
                                            <span className="fa fa-print icon"></span>
                                            <div>+65 63980700</div>
                                        </li>
                                    </ul>
                                    <p></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ContactUs